import { Component, EventEmitter, inject, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
	FormGroupComponent,
	InputComponent,
	ModalComponent,
	TagIconComponent,
	TextareaComponent,
} from '@tecalisdev/infinity';
import { LoadingService } from '../../../shared/services/loading.service';
import { ReactiveFormsService } from '../../../shared/services/reactive-forms.service';
import { PanelService } from '../../services/panel.service';
import { PhoneInputComponent } from '../../../shared/components/phone-input/phone-input.component';
import { requiredPhoneE164Validator } from '../../../shared/validators/phone-e164.validator';

@Component({
	selector: 'app-modal-contact-expert',
	imports: [
		ReactiveFormsModule,
		TranslatePipe,
		ModalComponent,
		FormGroupComponent,
		InputComponent,
		PhoneInputComponent,
		TextareaComponent,
		TagIconComponent,
	],
	templateUrl: './modal-contact-expert.component.html',
	styleUrl: './modal-contact-expert.component.scss',
})
export class ModalContactExpertComponent {
	@Output() closeEvent = new EventEmitter<void>();

	public reactiveFormService = inject(ReactiveFormsService);
	private panelService = inject(PanelService);
	private loading = inject(LoadingService);
	private trans = inject(TranslateService);

	public form: FormGroup = new FormGroup({
		name: new FormControl('', Validators.required),
		surnames: new FormControl('', Validators.required),
		email: new FormControl('', [Validators.required, Validators.email]),
		phone: new FormControl('', [Validators.required, requiredPhoneE164Validator()]),
		message: new FormControl('', Validators.required),
	});

	public showForm: boolean = true;
	public showSuccess: boolean = false;
	public showError: boolean = false;
	public submitting: boolean = false;

	public closeModal(action: string): void {
		// Botón OK en modal de error
		if (action === 'buttonPrimary' && this.showError) {
			// Ocultar modal de error y volver a mostrar el formulario
			this.showError = false;
			this.showForm = true;
			return;
		}

		this.closeEvent.emit();
	}

	public handleFormSubmit(action: string): void {
		// Evitar envíos dobles
		if (this.submitting) return;

		if (action === 'buttonPrimary') this.submitForm();
		else this.closeEvent.emit();
	}

	private submitForm(): void {
		if (this.form.invalid) {
			this.form.markAllAsTouched();
			return;
		}

		this.submitting = true;
		this.loading.show(this.trans.instant('LOADING.SEND_CONTACT_EXPERT'));
		this.panelService.contactExpert(this.form.getRawValue()).subscribe({
			next: () => {
				this.handleContactExpertResponse(true);
			},
			error: () => {
				this.handleContactExpertResponse(false);
			},
		});
	}

	private handleContactExpertResponse(success: boolean): void {
		this.submitting = false;
		this.loading.hide();
		this.showForm = false;

		if (success) {
			this.showSuccess = true;
			this.form.reset();
		} else {
			// Mostrar modal de error para que el usuario pueda volver a intentarlo
			this.showError = true;
		}
	}
}
